module.exports = __webpack_public_path__ + "media/images/lesson_5/sebastiao_varios_pensamentos-7b30733731f67531331f1dd7956e7710.png";